export const iconFontAwesomeTransportationBicycle = (
	<i className="fa-solid fa-bicycle"></i>
);
